var _defs, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 477.34 375.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c1c1c;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 959.9,
    cy: 661.23,
    r: 28.86,
    transform: "translate(-828.46 777.5) rotate(-58.28)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 959.9,
    cy: 488.06,
    r: 48.1,
    transform: "translate(-807.68 -119.05) rotate(-13.28)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M959.9,385.8a102.27,102.27,0,1,0,102.27,102.26A102.37,102.37,0,0,0,959.9,385.8Zm0,194.53a92.27,92.27,0,1,1,92.27-92.27A92.37,92.37,0,0,1,959.9,580.33Z",
    transform: "translate(-721.23 -352.65)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1074,352.65H845.8a23.69,23.69,0,0,0-23.67,23.67V704.57a23.69,23.69,0,0,0,23.67,23.67H1074a23.7,23.7,0,0,0,23.67-23.67V376.32A23.7,23.7,0,0,0,1074,352.65Zm13.67,351.92A13.69,13.69,0,0,1,1074,718.25H845.8a13.69,13.69,0,0,1-13.68-13.68V376.32a13.69,13.69,0,0,1,13.68-13.68H1074a13.69,13.69,0,0,1,13.67,13.68Z",
    transform: "translate(-721.23 -352.65)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M801,416.16,793.1,410a127,127,0,0,0,.73,157l7.83-6.22A117,117,0,0,1,801,416.16Z",
    transform: "translate(-721.23 -352.65)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M765,389.55l-7.88-6.15a170,170,0,0,0,1,210.26l7.82-6.22A160.05,160.05,0,0,1,765,389.55Z",
    transform: "translate(-721.23 -352.65)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1118.82,416.16a117,117,0,0,1-.67,144.67l7.82,6.22a127,127,0,0,0,.73-157Z",
    transform: "translate(-721.23 -352.65)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1162.67,383.4l-7.88,6.15a160,160,0,0,1-.93,197.89l7.82,6.22a170,170,0,0,0,1-210.26Z",
    transform: "translate(-721.23 -352.65)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.a696fdb28d799412a4f3c197000b9587.svg";
export { ForwardRef as ReactComponent };